import TaskCreateDialog from "./TaskCreateDialog";

/**
 * TaskEditDialog — spec 2026-02-18 point 4.
 *
 * "Le formulaire de modification est identique à la création."
 *
 * On rend donc le composant TaskCreateDialog en passant l'``existingTask``.
 * Il détecte le mode et bascule seul : titre, libellé submit, verbe HTTP
 * (PATCH au lieu de POST), pré-remplissage complet de tous les champs.
 * `onUpdated` renvoie le doc frais mis à jour par le backend.
 */
export default function TaskEditDialog({ open, onOpenChange, task, users, projects, onUpdated }) {
  return (
    <TaskCreateDialog
      open={open}
      onOpenChange={onOpenChange}
      users={users}
      projects={projects}
      existingTask={task}
      onUpdated={onUpdated}
    />
  );
}
